export default null;

// dispatcher requests
export const GET_BRIDGE_DATA = 'GET_BRIDGE_DATA';

// native bridge methods
export const CLOSE_WINDOW = 'CLOSE_WINDOW';
export const SHOW_WEBVIEW = 'SHOW_WEBVIEW';
export const SEND_GOOGLEAN_ALYTICS_EVENT = 'SEND_GOOGLEAN_ALYTICS_EVENT';
export const SHOW_PRODUCT = 'SHOW_PRODUCT';
export const SHOW_CATEGORY = 'SHOW_CATEGORY';
export const SELECT_PRODUCT_FROM_MODAL_CATALOG = 'SELECT_PRODUCT_FROM_MODAL_CATALOG';
export const SHOW_CUSTOMER = 'SHOW_CUSTOMER';
export const SET_WINDOW_TITLE = 'SET_WINDOW_TITLE';
export const CREATE_ORDER = 'CREATE_ORDER';
export const SHOW_CUSTOMER_INFO_MODAL = 'SHOW_CUSTOMER_INFO_MODAL';
export const SHOW_CUSTOMER_SELECTION_MODAL = 'SHOW_CUSTOMER_SELECTION_MODAL';
export const SIGN_IN_TO_GOOGLE = 'SIGN_IN_TO_GOOGLE';
export const DISCONNECT_FROM_GOOGLE = 'DISCONNECT_FROM_GOOGLE';
export const SIGN_OUT_FROM_GOOGLE = 'SIGN_OUT_FROM_GOOGLE';
export const ADD_LEFT_NAVBAR_BUTTON = 'ADD_LEFT_NAVBAR_BUTTON';
export const ADD_RIGHT_NAVBAR_BUTTON = 'ADD_RIGHT_NAVBAR_BUTTON';
export const REMOVE_LEFT_NAVBAR_BUTTON = 'REMOVE_LEFT_NAVBAR_BUTTON';
export const REMOVE_RIGHT_NAVBAR_BUTTON = 'REMOVE_RIGHT_NAVBAR_BUTTON';
export const REQUEST_NEW_TULIP_AUTH_TOKEN = 'REQUEST_NEW_TULIP_AUTH_TOKEN';
export const USER_ASSOCIATIONS_UPDATED = 'USER_ASSOCIATIONS_UPDATED';
export const CUSTOMER_ACTIVITY_LOG_UPDATED = 'CUSTOMER_ACTIVITY_LOG_UPDATED';
export const EDIT_CUSTOMER_MODAL = 'EDIT_CUSTOMER_MODAL';
export const CALL_CUSTOMER = 'CALL_CUSTOMER';



// WEBPACK FOOTER //
// ./src/WebBridge/actions.js